import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/app.css';
import { env } from './config/env.ts';
import { installGlobalErrorHandlers } from './lib/telemetry.ts';
import { App } from './app/App.tsx';
import { ConfigMissing } from './app/ConfigMissing.tsx';
import { RootErrorBoundary } from './app/resilience.tsx';

installGlobalErrorHandlers();
if (env.sentryDsn) {
  void import('./lib/sentry.ts').then(({ initSentry }) =>
    initSentry({ dsn: env.sentryDsn, environment: env.sentryEnvironment, release: env.release }),
  );
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <RootErrorBoundary>{env.configured ? <App /> : <ConfigMissing />}</RootErrorBoundary>
  </StrictMode>,
);
